import { useDataProvider } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { PageSection } from '@product-framework/index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import getConfig from '../../../configs/sp-location-config';
import PerformanceForm from '../../../components/PerformanceForm';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../utils/getSPLevelStackableButtons';

const FORM_ID = 'ServiceProviderLocationPerformance';

function LocationPerfomance() {
  const navigate = useNavigate();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);
  const { serviceProviderId, locationId, refreshData } = useServiceProvider();

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
    locationId,
  });

  const onChange = () => {
    refreshData({
      refreshLocation: true,
      refreshProfileWarnings: true,
    });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_PERFORMANCE"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={
          <FormattedMessage
            id="SERVICE_PROVIDER_PERFORMANCE"
            defaultMessage="Service Provider Performance"
          />
        }>
        <PerformanceForm formId={FORM_ID} config={config} onChange={onChange} />
      </PageSection>
    </ServiceProviderLayout>
  );
}

const LocationPerfomanceObserver = observer(LocationPerfomance);
export default withServiceProvider(LocationPerfomanceObserver);
